// extracted by mini-css-extract-plugin
export default {"parentFolder___tree":"CreateNewScriptModal_parentFolder___tree__+Ifnm"};